// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueJdbGameParser from 'vue-jdb-game-parser'
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'vue-jdb-game-parser/dist/vue-jdb-game-parser.css'
import eventBus from './setup/eventBus'

var VueTouch = require('vue-touch')
Vue.use(VueTouch)
Vue.use(VueJdbGameParser)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data () {
    return {
      // Bind event bus to $root Vue model
      bus: eventBus
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js